import React from 'react';
import { Users, Stethoscope, Leaf, ShieldCheck } from 'lucide-react';
const trustItems = [{
  icon: <Users size={20} data-id="element-159" />,
  text: '80.000+ zufriedene Kunden'
}, {
  icon: <Stethoscope size={20} data-id="element-160" />,
  text: 'Von Tierärzten empfohlen'
}, {
  icon: <Leaf size={20} data-id="element-161" />,
  text: '100% pflanzlich & natürlich'
}, {
  icon: <ShieldCheck size={20} data-id="element-162" />,
  text: 'Geld-zurück-Garantie'
}];
export function TrustBar() {
  return <div className="w-full bg-forest-green text-white py-6 px-4" data-id="element-163">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center" data-id="element-164">
        {trustItems.map((item, index) => <div key={index} className="flex items-center gap-2 font-medium text-sm md:text-base" data-id="element-165">
            <span className="text-cream" data-id="element-166">{item.icon}</span>
            <span data-id="element-167">{item.text}</span>
          </div>)}
      </div>
    </div>;
}